@use "../../styles/breakpoint.module.scss" as *;

.modal {
    background-color: var(--white);
    max-height: calc(100vh - var(--header-height));
    overflow: auto;
    display: flex;
    flex-flow: column wrap;
    align-items: stretch;
    padding: 0 var(--spacer-margin) var(--spacer-40) var(--spacer-margin);
    width: 100%;

    svg {
        width: 0.75em;
        height: 0.75em;
    }
}

.input {
    position: sticky;
    top: 0;
    padding-top: var(--spacer-40);
    background: var(--color-primary);
}

.counter {
    composes: fontST16 from "../../styles/typography.module.scss";
    display: inline-block;
    margin-block: var(--spacer-32);
}

.results {
    min-width: 100%;
    background-color: var(--color-primary);

    & > .item {
        display: grid;
        grid-template-columns: 1fr;
        padding: var(--spacer-16);
    }
}

.item {
    composes: base from "../Clickables/index.module.scss";

    span:has(strong) {
        color: var(--dark-gray);
    }

    strong {
        color: var(--black);
    }

    &[data-focus-visible],
    &[data-hovered] {
        outline: none;
        background-color: var(--light-gray);
    }
}

.title {
    composes: fontHB24 from "../../styles/typography.module.scss";
}

.subtitle {
    composes: fontP16 from "../../styles/typography.module.scss";
    margin-top: var(--spacer-12);
}

.showAll {
    composes: buttonTextPrimary from "../Clickables/index.module.scss";
    margin-top: var(--spacer-32);
}
